import withAuthHeader from '../../utils/withAuthHeader'
import checkAuthorizationError from '../../utils/checkAuthorizationError';
import { mapFetchCategoriesResponse, mapFetchCupomIdResponse, mapFetchCupomUseResponse, mapFetchCuponsResponse, mapFetchProductsResponse, mapFetchStoresResponse, mapFetchUsersResponse } from '../mappers/coupon';

export const actionTypes = {
    GET_STORE_SEARCH: 'GET_STORE_SEARCH',
    GET_USER_SEARCH: 'GET_USER_SEARCH',
    SET_NEW_CUPOM: 'SET_NEW_CUPOM',
    SET_RENEW_CUPOM: 'SET_RENEW_CUPOM',
    GET_CUPONS: 'GET_CUPONS',
    GET_CUPOM_DATA_USE: 'GET_CUPOM_DATA_USE',
    SET_CUPOM_REMOVE: 'SET_CUPOM_REMOVE',
    SET_CUPOM_STATUS: 'SET_CUPOM_STATUS'
}

export const fetchCupons = () => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });

        const response = mapFetchCuponsResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.GET_CUPONS,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchCupomId = (cupomId) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons/${cupomId}`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });

        const response = mapFetchCupomIdResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.GET_CUPOM_DATA_USE,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchCupomDataUse = (cupomId) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons/obterusos/${cupomId}`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });

        const response = mapFetchCupomUseResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.GET_CUPOM_DATA_USE,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const postRenewCupom = (data) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const apiData = data
        const url = `api/v1/dashboard/cupons/renovar`;
        const apiResponse = await api.put(url, apiData, {
            ...withAuthHeader()
        });
        const response = apiResponse.data;

        result = {
            success: true,
            data: response
        }

        dispatch({
            type: actionTypes.SET_RENEW_CUPOM,
            payload: {
                success: true
            }
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchStores = (search) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons/autocompleteestabelecimento?nomeEstabelecimento=${search}`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });

        const response = mapFetchStoresResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.GET_STORE_SEARCH,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}


export const fetchProductsByName = (productName, storeId) => async (dispatch, getState, api) => {
    let result = {};
    try {
        const url = `api/v1.0/cardapios/produtos/getbyname`;
        const apiResponse = await api.get(url, {
            params: {
                name: productName,
                ...(storeId ? { EstabelecimentoId: storeId } : {})
            },
            ...withAuthHeader(),
        });
        const response = mapFetchProductsResponse(apiResponse.data);
        result = {
            success: true,
            data: response,
        };
    } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
            error: e.message,
            data: []
        };
    }
    return result;
}

export const fetchCategoriesByName = (categoryName, storeId) => async (dispatch, getState, api) => {
    let result = {};
    try {
        const url = `api/v1.0/cardapios/categorias/getbyname`;
        const apiResponse = await api.get(url, {
            params: {
                name: categoryName,
                ...(storeId ? { EstabelecimentoId: storeId } : {})
            },
            ...withAuthHeader(),
        });
        const response = mapFetchCategoriesResponse(apiResponse.data);
        result = {
            success: true,
            data: response,
        };
    } catch (e) {
        checkAuthorizationError(e, dispatch);
        result = {
            error: e.message,
            data: []
        };
    }
    return result;
};


export const fetchUsers = (search) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons/autocompleteusuario?emailUsuario=${search}`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });
        const response = mapFetchUsersResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.GET_USER_SEARCH,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const postCupom = (data) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const apiData = data
        const url = `api/v1/dashboard/cupons`;
        const apiResponse = await api.post(url, apiData, {
            ...withAuthHeader()
        });
        const response = apiResponse.data;

        result = {
            success: true,
            data: response
        }

        dispatch({
            type: actionTypes.SET_NEW_CUPOM,
            payload: {
                success: true
            }
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const editCupom = ({ data, cupomId }) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const apiData = data
        const url = `api/v1/dashboard/cupons/${cupomId}`;
        const apiResponse = await api.post(url, apiData, {
            ...withAuthHeader()
        });
        const response = apiResponse.data;

        result = {
            success: true,
            data: response
        }

        dispatch({
            type: actionTypes.SET_NEW_CUPOM,
            payload: {
                success: true
            }
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const removeCupom = (cupomId) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons/deletar/${cupomId}`;
        const apiResponse = await api.put(url, '', {
            ...withAuthHeader()
        });

        const response = apiResponse.data;
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.SET_CUPOM_REMOVE,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const statusCupom = (cupomId) => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/cupons/alternarStatus/${cupomId}`;
        const apiResponse = await api.put(url, '', {
            ...withAuthHeader()
        });

        const response = apiResponse.data;
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.SET_CUPOM_STATUS,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}
